import {
    MenuItemProps,
    useRuntimeEnv,
    useTranslationLang,
    useTranslationRoute,
    useTranslations,
} from "@bsm/component";
import { useMemo } from "react";
import { useLangMenuItems } from "../../layout/hooks/useLangMenuItems";

export const useAvatarMenuItems = () => {
    const { runtimeEnv } = useRuntimeEnv();
    const [PROFILE, LOGOUT] = useTranslations(i18n);
    const translationRoute = useTranslationRoute();
    const itemsLang = useLangMenuItems();
    const isInAdmin = location.pathname.split("/").includes("admin");
    const { lang } = useTranslationLang()

    return useMemo((): Array<MenuItemProps> => {
        return [
            {
                label: PROFILE,
                link: translationRoute(
                    `${isInAdmin ? "admin/" : ""}user/${runtimeEnv?.personnel.id}/about`
                ),
                startIcon: "fa-solid fa-user",
            },
            {
                divide: true,
            },
            ...itemsLang,
            {
                divide: true,
            },
            {
                label: LOGOUT,
                "data-testid": "avatar-menu-logout",
                link: translationRoute(`logout`),
                startIcon: "fa-solid fa-right-from-bracket",
            },
        ];
    }, [lang]);
};

const i18n = ["std_profil", "std_logout"];
